<template>
  <AdviserChannelPage :channel="channel" />
</template>

<script>
  import { PF_CHANNEL } from '@/constants/adviser-enrolment/pf-content';
  import AdviserChannelPage from './AdviserChannelPage.vue';

  export default {
    name: 'PfaAdviserEnrolment',
    components: {
      AdviserChannelPage,
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    data() {
      return {
        channel: PF_CHANNEL,
      };
    },
  };
</script>
